/**********************************************************************************
 **
 **              jQuery Tristate Checkbox Plugin
 **              version: 1.01
 **
 **              Dual licensed under the MIT and GPL licenses:
 **              http://www.opensource.org/licenses/mit-license.php
 **              http://www.gnu.org/licenses/gpl.html
 **
 **              author: Jeff Leombruno
 **  ->  ->  ->  NOTE: This plugin is modified to fit Talkable needs,
 **  ->  ->  ->  compare with official plugin before upgrade.
 **
 **********************************************************************************/

(function($){
  $.fn.tristate = function(options){
  
    var config = {
      selector: $(this).selector,
      checked: null,
      container: null,
      siblings: null
    };
    var opts = $.extend(config, options);
    
    return this.each(function(){
      var obj = $(this);
      
      var triState = function() {
      
        var pub = {};
        
        pub.init = function(){
          $('input[type="checkbox"]', obj).change(function(e) {
            config.checked = $(this).prop("checked");
            config.container = $(this).parent();
            config.siblings = config.container.siblings();

            config.container.find('input[type="checkbox"]').prop({
              indeterminate: false,
              checked: config.checked
            }).next().removeClass("is-indeterminate");
            
            pub.checkSiblings(config.container);
          });
          // run checkSiblings for every checked checkbox when the page loads
          $('input[type=checkbox]:checked', obj).trigger('change');
        };
        
        pub.checkSiblings = function(el) {
          var parent = el.parent().parent();
          var all = true;

          el.siblings().each(function() {
            return all = ($(this).children('input[type="checkbox"]').prop("checked") === config.checked);
          });

          if (all && config.checked) {
            parent.children('input[type="checkbox"]').prop({
              indeterminate: false,
              checked: config.checked
            }).next().removeClass("is-indeterminate");
            pub.checkSiblings(parent);
          } else if (all && !config.checked) {
            parent.children('input[type="checkbox"]').prop("checked", config.checked);

            if (parent.find('input[type="checkbox"]:checked').length) {
              parent.children('input[type="checkbox"]')
                .prop("indeterminate", true)
                .next().addClass("is-indeterminate");
            } else {
              parent.children('input[type="checkbox"]')
                .prop("indeterminate", false)
                .next().removeClass("is-indeterminate");
            }

            pub.checkSiblings(parent);
          } else {
            el.parents("li").children('input[type="checkbox"]').prop({
              indeterminate: true,
              checked: false
            }).next().addClass("is-indeterminate");
          }
        };
        
        return pub;
      }();
      
      triState.init();
      triState.checkSiblings(obj);
      
    });
  };
})(jQuery);
